export default __webpack_public_path__ + "static/media/portfolio-113.b7de5ca4.jpg";